"use strict";
(function() {
  const $ = require('jQuery');
  const machinemotion = require('./api/machinemotion');
  const api_request = require('./api/api_request');
  const machinelogic = require('./machinelogic');
  const style = require('./legacy/style');
  const widgets = require('./legacy/widgets');
  const widgets_ml = require('./legacy/machinelogic_widgets');
  const environment = require('./environment');
  const components = require('./components');
  const machine_app_state = require('./machine_app/models/machine_app_state');
  const edge_machine_app_interface = require('./machine_app/edge_machine_app_interface');

  /**
   * The currently used machinelogic library.
   * Don't use this if you can help it, we're trying to get rid of it.
   *
   * @deprecated
   */
  let gLibrary;

  const { controlCenter } = require("@ventionco/mm-machine-logic-robot");
  const {
    utils: { isRobotReady: isRobotReadyWithoutEnvironment, robotTypeFormatUR },
    view: { ManualControlRobotJoggerContainer }
  } = controlCenter;
  const isRobotReady = isRobotReadyWithoutEnvironment(environment);

  /**
   * @param {Library} pLibrary
   * @param {Navigate} pNavigate
   * @param {Object} [pOptions]
   * @param {boolean} [pOptions.renderUi] Whether to render the UI. Defaults to true.
   * @param {JQuery} [pOptions.leftPane] Left pane
   * @param {JQuery} [pOptions.rightPane] Right pane
   * @param {() => void} [pOptions.navigateToLandingPage] Function to navigate to the landing page
   * @param {(app) => void} [pOptions.onApplicationUploaded] Funcation to call when an application is uploaded
   */
  function standalone(pLibrary, pNavigate, pOptions = { renderUi: true, navigateToLandingPage: () => {}, onApplicationUploaded: (app) => {} }) {
    // Report MachineMotion errors on toasters
    // onMMError receives a parameter that is a string but is not being used. Using hardcoded errorMsg instead.
    function onMMError() {
      const errorMsg = "Invalid application, changes can't be saved.";
      widgets.messageBox(errorMsg, 'error');
    }

    // TODO GD We need to clean this up at some point?
    // Or make sure we only do it once
    machinemotion.addErrorHandler(onMMError);

    machinemotion.isAvailable(pAvailable => {
      if (pAvailable) {
        startVSE(pLibrary, pNavigate, pOptions);

        return;
      }

      const lReconnectButton = widgets_ml.reconnectWidget(() => {
        machinemotion.isAvailable(pAvailable => {
          if (pAvailable) {
            lReconnectButton.remove();
            startVSE(pLibrary, pNavigate, pOptions);
          }
        });
      });

      $('#bottom_bar').append(lReconnectButton);
    });
  }

  /**
   * @param {Library} pLibrary
   * @param {Navigate} pNavigate
   * @param {Object} options
   * @param {boolean} options.renderUi Whether to render the UI.
   */
  function startVSE(pLibrary, pNavigate, { renderUi, leftPane, rightPane, navigateToLandingPage, onApplicationUploaded }) {
    if (renderUi) {
      buildUi(pLibrary, pNavigate, {leftPane, rightPane, navigateToLandingPage, onApplicationUploaded});
    }

    addErrorBadgeToMachineLogicIconButton(pLibrary);
  }

  function buildUi(pLibrary, pNavigate, {leftPane, rightPane, navigateToLandingPage, onApplicationUploaded}) {
    const lTabPane = $('#tab_pane');
    // If the panes are not passed in the options there's a chance they will not be found in the DOM
    const lLeftPane = leftPane || $('#left_pane');
    const lRightPane = rightPane || $('#right_pane');
    const _lBottomBar = $('#bottom_bar');
    const _lMLParametersGrid = 'grid-template-columns: repeat(5, 1fr);';
    // Note (alevy): ml_parameters layout is different for MMv1 and MMv2
    style.defineCssRule('.ml_parameters.machine_motion_config', _lMLParametersGrid);

    const lParamString = window.location.search;
    const lSearchParams = new URLSearchParams(lParamString);

    // Populate the panes with the editor
    widgets_ml.editor({
      pendantNavigate: pNavigate,
      library: pLibrary,
      user: null,
      viewType: environment.getPage(),
      controllerContainer: lTabPane,
      leftContainer: lLeftPane,
      rightContainer: lRightPane,
      getPlayerWidget: () => widgets_ml.playerWidget(pLibrary, isRobotReady),
      addMachineApp: undefined,
      machineAppProps: {
        selectedAppType: lSearchParams.get('type') || 'path_following', //HACK for PATH-FOLLOWING-VENTION-IO. we go right to path following
        selectedViewType: lSearchParams.get('view')
      },
      configurationProps: {
        toolbarProps: {
          showRobotAddButton: false,
          onNewRobot: (_pController) => {
            // this is where we will handle adding robots in the control center.
          }
        }
      },
      applicationProps: {
        selectedApp: JSON.parse(localStorage.getItem('mName'))
      },
      navigationProps: {
        openApplicationLandingPage: navigateToLandingPage,
        openMachineLogicAppEditor: () => {},
        // TODO: (Ben R.) Right now, we don't have a way to get back to
        // machineAppApplicationView, so we go to applicationLandingPage instead
        openMachineAppApplicationView: navigateToLandingPage
      },
      onApplicationUploaded: onApplicationUploaded
    });

    // Clear out local storage after a page reload
    localStorage.removeItem('mName');

    // Special layout for on MachineMotion vse
    if (environment.isOnConfigPage()){
      $('body').on('contextmenu', function(pEvent) {
        pEvent.preventDefault();
      });
      return;
    }

    // Layout and style for standalone application
    // please see ticket VentionCo/mm-vention-control#597
    if (!environment.isOnConfigPage()) {
      $('li.ml_config').hide();
      lRightPane.addClass('bordered');
    } else {
      _lBottomBar.append(widgets_ml.playerWidget(pLibrary, isRobotReady));
    }
    $('body').on('contextmenu', function(pEvent) {
      pEvent.preventDefault();
    });
  }

  // TODO GD All of this should be done on the pendant side
  function addErrorBadgeToMachineLogicIconButton(pLibrary) {
    if (!pLibrary.getValidator().mHasRun) {
      pLibrary.getValidator().runValidation();
    }

    // The badge might already exist because the navbar is persistent
    // Ideally the pendant will take care of this, but for now we have to wait to the library to load
    // We don't await it and blah blah blah so for now we'll resort to this
    // Looking forward to removing this main.js file
    if ($("#ml_validator_badge_container").length === 0) {
      const lErrorCount = pLibrary.getValidator().getTotalErrors();

      // Add an error badge on the machine logic navbar link
      const lErrorBadge = $('<span class="ml_validator_badge_ml">')
        .css({ 'position': 'absolute','top': '2px','left': '38px'})
        .append(
          $('<span class="fas fa-exclamation">')
            .css({
              'color': 'white',
              'font-size': '8px'
            })
        );

      $('#navbar_item_vse').append(lErrorBadge);

      if (lErrorCount === 0) {
        $('.ml_validator_badge_ml').hide();
      }
    }

    pLibrary.addListener({
      onErrorCountChanged: function(pCount) {
        const lMachineLogicButton = $('.ml_validator_badge_ml');
        pCount ? lMachineLogicButton.show() : lMachineLogicButton.hide();
      }
    });
  }

  /**
   * Represents a Library Configuration needed to create a library.
   * (I don't know what this is, help!)
   *
   * @typedef {Object} LibraryConfiguration
   */

  /**
   * A set of functions to create and initialize MachineLogic related objects, states and services.
   *
   * @typedef {Object} MachineLogicFactory
   * @property {function(LibraryConfiguration): Promise<Library>} createLibrary A function to create and initialize a MachineLogic Library.
   * @property {function(Library, Navigate): Promise<Library>} initializeMachineApps A function to initialize the machine applications.
   */

  // TODO GD This should eventually live in MachineLogic 'core' in some shape or form
  /** @type MachineLogicFactory */
  const MachineLogicFactory = {
    createLibrary: (pLibraryConfig, machineLogicServices, pMachineLogicConfiguration) => {
      const newLibrary = new machinelogic.Library(pLibraryConfig, pMachineLogicConfiguration);
      gLibrary = newLibrary;

      return new Promise(resolve => {
        newLibrary.initialize(() => {
          newLibrary.getValidator().runValidation();
          resolve(newLibrary);
        }, machineLogicServices);
      });
    },
    initializeMachineApps: (pLibrary, pNavigate) => {
      return new Promise((resolve, reject) => {
        machine_app_state.initialize(
          require("@ventionco/machine-app-components"),
          pLibrary,
          machinemotion.getMachineAppLibrary,
          {
            upsert: machinemotion.upsertMachineAppItem,
            remove: function deleteMachineAppItem(pMachineAppType, pMachineAppItemType, pJson, pCompletion) {
              machinemotion.deleteMachineAppItem(pMachineAppType, pMachineAppItemType, pJson.uuid, pCompletion);
            },
            saveAll: machinemotion.setMachineAppLibrary
          },
          () => new edge_machine_app_interface.EdgeMachineAppInterface(pNavigate, pLibrary, machine_app_state.getLibraryManager()),
          pSuccess => {
            if (!pSuccess) {
              console.error('Unable to load machine apps.');
              reject();
            }
            else {
              resolve(pLibrary);
            }
          }
        );
      });
    }
  };

  /* Module export glue */
  /* global define */
  const gExports = {
    standalone,
    MachineLogicFactory,
    /**
     * Gets the currently used machinelogic library.
     * Don't use this if you can help it, it uses a global variable, and we're trying to get rid of it.
     *
     * @deprecated
     */
    getLibrary: () => gLibrary,
    setRemoteHost: api_request.setRemoteHost,

    // TODO GD Review these exports and remove everything we don't/shouldn't need
    getRemoteHost: api_request.getRemoteHost,
    getMachineAppState: () => machine_app_state,

    // We only need this for Cypress tests, cant make it work with webpack, any idea?
    machinemotion: machinemotion,
    components: components,
    widgets_ml: widgets_ml,
    manualControlRobotJogger: {
      ManualControlRobotJoggerContainer,
      robotTypeFormatUR,
    },
    isRobotReady,
    messageBox: widgets.messageBox,
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
})();
